<template>
  <div class="overflow-y-auto box-content">
    <div class="">
      <div class="flex items-center" style="width: 150px">
        <div>
          <img class="w-20 h-20" src="@/assets/images/logo.png" alt="logo" />
        </div>
        <div class="logo text-white font-semibold text-lg">AirsynQ</div>
      </div>

      <div>
        <button
          v-for="(nav, i) in navigation"
          :key="i"
          @click="$router.push(`${nav.to}`).catch(err => {})"
          class="flex items-center ml-5 text-white hover:text-white focus:text-white focus:outline-none opacity-50 hover:opacity-100 focus:opacity-100"
          style="width: 200px; margin-top: 3rem"
        >
          <!-- <i :class="[`${nav.icon}`, 'text-2xl']"></i> -->
          <img :src="nav.icon" alt=".." class="w-8 h-8" />
          <p class="logo font-semibold ml-6 text-left text-base">
            {{ nav.name }}
          </p>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["navigation"],
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.sideNav {
  transition: width 0.6s cubic-bezier(0.25, 0.45, 0.45, 0.95);
  width: 6.2rem;
  z-index: 111;
  position: absolute;
  display: block;

  &:hover {
    width: 15%;

    .logo {
      display: block;
    }
  }

  .logo {
    display: none;
  }
}
</style>
